/**
 * 由 `vite.config` 在构建时 `define` 注入，与仓库根 `.env.shared` 同源。
 * 勿在 Node 脚本中引用本文件（无 `define` 时回退为默认值）。
 */
import type { WatermarkExportMode } from '@imockup/shared-config'

export type { WatermarkExportMode }

declare const __IMOCKUP_LOGIN_TEST__: boolean | undefined
declare const __IMOCKUP_PUBLIC_SITE_NAME__: string | undefined
declare const __IMOCKUP_CLARITY_PROJECT_ID__: string | undefined
declare const __IMOCKUP_WATERMARK_EXPORT_MODE__: string | undefined
declare const __IMOCKUP_ANIMOCK_API_BASE__: string | undefined
declare const __IMOCKUP_ANIMOCK_STATIC_URL__: string | undefined

/** 与营销站 `runtimeConfig.public.loginTest` 对齐的登录测试开关。 */
export const IMOCKUP_LOGIN_TEST: boolean =
  __IMOCKUP_LOGIN_TEST__ === undefined ? false : Boolean(__IMOCKUP_LOGIN_TEST__)

/** 与 `PUBLIC_SITE_NAME` / `getSharedPublicSiteName()` 对齐的展示名。 */
export const IMOCKUP_PUBLIC_SITE_NAME: string =
  __IMOCKUP_PUBLIC_SITE_NAME__ !== undefined && __IMOCKUP_PUBLIC_SITE_NAME__
    ? String(__IMOCKUP_PUBLIC_SITE_NAME__)
    : 'Animock'

/** 与 `PUBLIC_CLARITY_PROJECT_ID` / 营销站 `runtimeConfig.public.clarityProjectId` 对齐。 */
export const IMOCKUP_CLARITY_PROJECT_ID: string =
  __IMOCKUP_CLARITY_PROJECT_ID__ !== undefined && __IMOCKUP_CLARITY_PROJECT_ID__
    ? String(__IMOCKUP_CLARITY_PROJECT_ID__)
    : ''

/**
 * AnimockServer 后端根 URL（与营销站 `runtimeConfig.animockApiBase` 同源；构建时 `define` 注入）。
 *
 * - dev：`.env.development` 默认 `http://127.0.0.1:8000`
 * - prod：`.env.production` 中 `ANIMOCK_API_BASE`（如 `https://server.animock.cn/index.php`）
 *
 * 末尾不含 `/`，便于直接拼 `${base}/api/...`。
 */
export const IMOCKUP_ANIMOCK_API_BASE: string =
  __IMOCKUP_ANIMOCK_API_BASE__ !== undefined && __IMOCKUP_ANIMOCK_API_BASE__
    ? String(__IMOCKUP_ANIMOCK_API_BASE__).replace(/\/+$/, '')
    : ''

/**
 * AnimockServer 静态资源根（与营销站 `runtimeConfig.public.animockStaticUrl` 同源）。
 * 未单独配置时与 {@link IMOCKUP_ANIMOCK_API_BASE} 相同。
 */
export const IMOCKUP_ANIMOCK_STATIC_URL: string =
  __IMOCKUP_ANIMOCK_STATIC_URL__ !== undefined && __IMOCKUP_ANIMOCK_STATIC_URL__
    ? String(__IMOCKUP_ANIMOCK_STATIC_URL__).replace(/\/+$/, '')
    : IMOCKUP_ANIMOCK_API_BASE

const wmRaw =
  __IMOCKUP_WATERMARK_EXPORT_MODE__ === undefined
    ? 'auto'
    : String(__IMOCKUP_WATERMARK_EXPORT_MODE__)

/**
 * 导出水印覆盖模式（与 `.env.shared` 中 `ANIMOCK_WATERMARK` 同源，构建时 `define` 注入）。
 */
export const IMOCKUP_WATERMARK_EXPORT_MODE: WatermarkExportMode =
  wmRaw === 'on' || wmRaw === 'off' ? wmRaw : 'auto'

/**
 * 结合订阅状态解析导出是否叠加平台水印。
 *
 * @param isSubscribed - 当前会话是否已订阅（未登录视为未订阅）
 */
export function resolveExportIncludeWatermark(isSubscribed: boolean | undefined): boolean {
  if (IMOCKUP_WATERMARK_EXPORT_MODE === 'on') return true
  if (IMOCKUP_WATERMARK_EXPORT_MODE === 'off') return false
  return !isSubscribed
}
